module.exports = __webpack_public_path__ + "fonts/MyriadPro-Regular.b9d7ffd.ttf";